import * as types from '../mutation-types'
import deepClone from '@/shared/utils/deep-clone'

// state
const state = {
  workOrde: [],
  control: {}
}

// getters
const getters = {
  workOrde: state => state.workOrde,
  control: state => state.control
}

// actions
const actions = {
  // 整个数组赋值给workOrde
  setWorkOrde ({ commit }, params) {
    commit(types.WORKORDER, params)
  },

  // 改变control，同时改变workOrde
  setControl ({ commit }, params) {
    commit(types.CONTROL, params)
  },

  // 通过control改变workOrde,不改变control
  setControlWorkOrde ({ commit }, params) {
    commit(types.CONTROLWORKORDE, params)
  },

  // 重置
  clearControl ({ commit }) {
    commit(types.CLEARCONTROL)
  }
}

// mutations
const mutations = {
  [types.WORKORDER] (state, params) {
    state.workOrde = deepClone(params)
  },

  [types.CONTROL] (state, params) {
    if (params.parentId) {
      state.control = deepClone(params)
      state.workOrde.forEach(res => {
        if (res.id === params.parentId) {
          res.controls.controlList.forEach(res2 => {
            if (res2.id !== params.id) return
            res2.controls = deepClone(params.controls)
          })
        }
      })
    } else {
      state.control = deepClone(params)
      let exist
      state.workOrde.forEach(res => {
        if (res.id !== params.id) return
        res.controls = deepClone(params.controls)
        exist = true
      })
      if (exist) return
      state.workOrde.push(deepClone(params))
    }
  },

  [types.CONTROLWORKORDE] (state, params) {
    if (!params) return
    state.workOrde.forEach(res => {
      if (res.id === params.id) {
        res.controls.controlList = deepClone(params.controls.controlList)
        if (!state.control) return
        state.control.controls.controlList = deepClone(params.controls.controlList)
      }
    })
  },

  [types.CLEARCONTROL] (state, params) {
    state.workOrde = []
    state.control = ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
